/**
 * Shared formatting utilities for CRUD viewer components.
 */

import { formatDateByTag } from '@ja/core-ui/lib/date';

const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

/** Detect whether a value looks like an ISO date string. */
export function looksLikeDate(value: unknown): value is string {
    if (typeof value !== 'string') return false;
    return ISO_DATE_RE.test(value) || DATE_ONLY_RE.test(value);
}

/** Format an ISO date string for display using the vue-i18n locale tag. */
export function formatDate(value: string, locale?: string | null): string {
    return formatDateByTag(value, locale);
}

/** Auto-format a value: detects dates, booleans, arrays, and falls back to String(). */
export function autoFormat(
    value: unknown,
    yesLabel = 'Yes',
    noLabel = 'No',
    locale?: string | null,
): string {
    if (value === null || value === undefined || value === '') return '—';
    if (typeof value === 'boolean') return value ? yesLabel : noLabel;
    if (Array.isArray(value)) return value.length > 0 ? value.join(', ') : '—';
    if (looksLikeDate(value)) return formatDate(value, locale);
    if (typeof value === 'object') return JSON.stringify(value, null, 2);
    return String(value);
}
